import { Plus } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { IPricingProfileAccessItem } from 'pricing/types';
import { Color } from 'theme/enums';

import { UpsertPricingProfileAccess } from './UpsertPricingProfileAccess';

interface IProps {
  pricingProfileAccessItem?: IPricingProfileAccessItem;
  pricingProfileId: number;
  buttonElement?: ReactElement;
  onSubmitSuccess: () => void;
  onRemoveSuccess?: () => void;
  disabled?: boolean;
}

export const UpsertPricingProfileAccessButton = ({
  pricingProfileAccessItem,
  pricingProfileId,
  buttonElement,
  onSubmitSuccess,
  onRemoveSuccess,
  disabled = false,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const button = buttonElement ? (
    cloneElement(buttonElement, {
      onClick: disabled ? undefined : () => setIsOpen(true),
    })
  ) : (
    <Button
      text={t('buttonLabelAddAccess')}
      color={Color.SUCCESS}
      startDecorator={<Plus />}
      onClick={() => setIsOpen(true)}
      disabled={disabled}
    />
  );

  return (
    <>
      {button}

      <UpsertPricingProfileAccess
        pricingProfileAccessItem={pricingProfileAccessItem}
        pricingProfileId={pricingProfileId}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmitSuccess={onSubmitSuccess}
        onRemoveSuccess={onRemoveSuccess}
      />
    </>
  );
};
